// Desktop header search field. Reuses the theme's PredictiveSearch (search.js, loaded by the
// search drawer section) but renders suggestions into its own dropdown instead of the drawer.
customElements.whenDefined('predictive-search').then(() => {
  if (customElements.get('header-predictive-search')) return;

  const PredictiveSearch = customElements.get('predictive-search');

  class HeaderPredictiveSearch extends PredictiveSearch {
    constructor() {
      super();
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.input.blur();
      });
      this.addEventListener('focusin', () => this.toggleExpanded());
      this.addEventListener('focusout', () => setTimeout(() => this.toggleExpanded()));
      this.addEventListener('submit', (event) => {
        if (this.getQuery().length === 0) {
          event.preventDefault();
          this.input.focus();
        }
      });
    }

    // Suggestions are rendered by the search drawer section, which contains the predictive results markup.
    get sourceSectionId() {
      const drawer = document.getElementById('SearchDrawer');
      return drawer ? FoxTheme.utils.getSectionId(drawer) : null;
    }

    get resultsElement() {
      return this.querySelector('#HeaderPredictiveSearchResults');
    }

    setupURL() {
      const url = super.setupURL();
      url.searchParams.set('section_id', this.sourceSectionId);
      return url;
    }

    onChange() {
      if (!this.sourceSectionId) return;
      super.onChange();
    }

    clear(event = null) {
      super.clear(event);
      this.toggleExpanded();
    }

    renderSearchResults(responseText) {
      const parsedDoc = new DOMParser().parseFromString(responseText, 'text/html');
      const contentElement = parsedDoc.getElementById(`PredictiveSearchResults-${this.sourceSectionId}`);
      if (!contentElement || !this.resultsElement) return;

      this.resultsElement.innerHTML = contentElement.innerHTML;
      this.searchContent?.classList.remove('hidden');
      // The base class sets the `results` attribute after this runs.
      setTimeout(() => this.toggleExpanded());
    }

    toggleExpanded() {
      const expanded = this.contains(document.activeElement) && this.hasAttribute('results') && this.getQuery().length > 0;
      this.input.setAttribute('aria-expanded', expanded);
    }
  }

  customElements.define('header-predictive-search', HeaderPredictiveSearch, { extends: 'form' });
});
